import { UsercardListComponent } from './usercard-list.component.js';
import { UsercardViewComponent } from './usercard-view.component.js';
import { UsercardService } from './usercard.service.js';

export const scUsercardModule = 'sc-usercard';

angular.module(scUsercardModule, [])
    .service('UsercardService', UsercardService)
    .directive('scUsercardList', UsercardListComponent)
    .directive('scUsercardView', UsercardViewComponent);
    



// WEBPACK FOOTER //
// ./src/usercard/usercard.module.js